module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_0.80f39a99.png";